import { ViewStudy } from './view-study';
import { SeriesMeta } from './series-meta';
import { clone } from 'lodash-es';

export const mergeStudyArrays = (params: {
    toMerge: Array<ViewStudy>;
    existing: Array<ViewStudy>;
}): Array<ViewStudy> => {
    const { toMerge, existing } = params;
    let output: ViewStudy[] = [];

    let idxExisting = 0;
    let idxToMerge = 0;
    while (idxExisting < existing.length && idxToMerge < toMerge.length) {
        if (existing[idxExisting].data.id < toMerge[idxToMerge].data.id) {
            output.push(existing[idxExisting++]);
        } else if (existing[idxExisting].data.id > toMerge[idxToMerge].data.id) {
            output.push(toMerge[idxToMerge++]);
        } else {
            output.push(mergeStudies({ existing: existing[idxExisting++], merge: toMerge[idxToMerge++] }));
        }
    }
    while (idxExisting < existing.length) {
        output.push(existing[idxExisting++]);
    }
    while (idxToMerge < toMerge.length) {
        output.push(toMerge[idxToMerge++]);
    }
    return output;
};

const mergeStudies = (params: { merge: ViewStudy; existing: ViewStudy }): ViewStudy => {
    const { merge, existing } = params;
    let result: ViewStudy = clone(existing);
    result.data.series = mergeSeriesArrays({ toMerge: merge.data.series, existing: existing.data.series });
    result.viewModality = new Set([...existing.viewModality, ...merge.viewModality]);

    return result;
};

const mergeSeriesArrays = (params: { toMerge: SeriesMeta[]; existing: SeriesMeta[] }): SeriesMeta[] => {
    const { toMerge, existing } = params;
    let output: SeriesMeta[] = [];
    let idxExisting = 0;
    let idxToMerge = 0;
    while (idxExisting < existing.length && idxToMerge < toMerge.length) {
        if (existing[idxExisting].id < toMerge[idxToMerge].id) {
            output.push(existing[idxExisting++]);
        } else if (existing[idxExisting].id > toMerge[idxToMerge].id) {
            output.push(toMerge[idxToMerge++]);
        } else {
            output.push(existing[idxExisting++]);
            ++idxToMerge;
        }
    }
    while (idxExisting < existing.length) {
        output.push(existing[idxExisting++]);
    }
    while (idxToMerge < toMerge.length) {
        output.push(toMerge[idxToMerge++]);
    }
    return output;
};
